import {
  Backdrop,
  Box,
  Card,
  Divider,
  Fade,
  Grid,
  Typography,
  Modal,
} from "@mui/material";
import CollapsePromotion from "../Collapse/promotion";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ConfirmationNumberIcon from "@material-ui/icons/ConfirmationNumber";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import moment from "moment";

const ModalPromotion = ({ open, setOpen, data, ChangeNumber }) => {
  const handleClose = () => setOpen(null);
  const Sheet = (sheet) => {
    if (sheet == "Set Pro Device")
      return (
        <Box
          component="span"
          className="text-white"
          style={{
            backgroundColor: "#0079D3",
            padding: "2px 8px",
            borderRadius: "36px",
            boxShadow: "0px 1px 2px rgba(105, 81, 255, 0.05)",
            fontWeight: 700,
          }}
        >
          Set Pro Device
        </Box>
      );
    else if ((sheet = "Set Pro BTB,DIY"))
      return (
        <Box
          component="span"
          className="text-white"
          style={{
            backgroundColor: "#008A60",
            padding: "2px 8px",
            borderRadius: "36px",
            boxShadow: "0px 1px 2px rgba(105, 81, 255, 0.05)",
            fontWeight: 700,
          }}
        >
          Set Pro BTB,DIY
        </Box>
      );
    else return null;
  };
  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="promotion-modal-title"
        aria-describedby="promotion-modal-description"
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box
            className="box-modal-promotion"
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              border: "1px solid #000",
              boxShadow: 24,
              p: 3,
            }}
          >
            {data.sheet && (
              <Box paddingBottom={2.5} paddingLeft={5} paddingRight={5}>
                {Sheet(data.sheet)}
              </Box>
            )}
            <Grid container padding={1} spacing={8}>
              <Grid item xs={6} md={4}>
                <Typography style={{ color: "#70798E" }}>
                  {" "}
                  Product Highlight:
                </Typography>
              </Grid>
              <Grid item xs={6} md={8}>
                <Typography
                  style={{
                    borderRadius: 4,
                    textAlign:
                      !data["Product Highlight"] ||
                      data["Product Highlight"] == "-"
                        ? "start"
                        : "center",
                    fontWeight: 700,
                    backgroundColor:
                      !data["Product Highlight"] ||
                      data["Product Highlight"] == "-"
                        ? "transparent"
                        : "cornsilk",
                    color: "black",
                  }}
                >
                  {" "}
                  {!data["Product Highlight"] ||
                  data["Product Highlight"] == "-"
                    ? "-"
                    : "Highlight"}
                </Typography>
              </Grid>
              <Grid item xs={6} md={4}>
                <Typography style={{ color: "#70798E" }}>ครั้งที่:</Typography>
              </Grid>
              <Grid item xs={6} md={8}>
                <Typography>{data["ครั้งที่"]}</Typography>
              </Grid>
              <Grid item xs={6} md={4}>
                <Typography style={{ color: "#70798E" }}>
                  {" "}
                  Campaign Name:
                </Typography>
              </Grid>
              <Grid item xs={6} md={8}>
                <Typography> {data["Campaign Name"]}</Typography>
              </Grid>
              <Grid item xs={6} md={4}>
                <Typography style={{ color: "#70798E" }}> Cat:</Typography>
              </Grid>
              <Grid item xs={6} md={8}>
                <Typography> {data[" Cat "]}</Typography>
              </Grid>
              <Grid item xs={6} md={4}>
                <Typography style={{ color: "#70798E" }}> Brand:</Typography>
              </Grid>
              <Grid item xs={6} md={8}>
                <Typography> {data[" Brand "]}</Typography>
              </Grid>
              <Grid item xs={6} md={4}>
                <Typography style={{ color: "#70798E" }}>
                  {" "}
                  Cat./Product Code:
                </Typography>
              </Grid>
              <Grid item xs={6} md={8}>
                <Typography> {data["Cat/Product Code"]}</Typography>
              </Grid>
              <Grid item xs={6} md={4}>
                <Typography style={{ color: "#70798E" }}>
                  {" "}
                  Sub.Cat./Product Name:
                </Typography>
              </Grid>
              <Grid item xs={6} md={8}>
                <Typography> {data[" SubCat/Product Name "]}</Typography>
              </Grid>
              <Grid item xs={6} md={4}>
                <Typography style={{ color: "#70798E" }}>
                  {" "}
                  รายละเอียด Promotion:
                </Typography>
              </Grid>
              <Grid item xs={6} md={8}>
                <Typography> {data[" รายละเอียด Promotion "]}</Typography>
              </Grid>
            </Grid>
            <Card style={{ marginTop: "10px" }}>
              <Grid container padding={2} spacing={3}>
                <Grid item xs={6} md={4}>
                  <Typography style={{ color: "#70798E" }}>
                    ราคาปกติ:
                  </Typography>
                </Grid>
                <Grid item xs={6} md={8} textAlign={"end"}>
                  <Typography>{data[" ราคาปกติ "]}</Typography>
                </Grid>
                <Grid item xs={6} md={4}>
                  <Box
                    style={{
                      fontWeight: 400,
                      fontSize: 14,
                      padding: "5px 0",
                      display: "flex",
                    }}
                  >
                    <Typography
                      style={{
                        width: "24px",
                        height: "24px",
                        borderRadius: "50%",
                        backgroundColor: "#FCEEF2",
                        color: "#70798E",
                        marginRight: 5,
                      }}
                    >
                      <ConfirmationNumberIcon
                        style={{
                          color: "red",
                          padding: 5,
                        }}
                      />
                    </Typography>{" "}
                    ส่วนลด
                  </Box>
                </Grid>
                <Grid item xs={6} md={8} textAlign={"end"}>
                  <Typography style={{ color: "red" }}>
                    -.
                    {Number.isNaN(
                      Number(ChangeNumber(data[" ราคาปกติ "])) -
                        Number(ChangeNumber(data[" ราคาโปรโมชั่น "]))
                    )
                      ? "ส่วนลดไม่ใช่ตัวเลข"
                      : Number(ChangeNumber(data[" ราคาปกติ "])) -
                        Number(ChangeNumber(data[" ราคาโปรโมชั่น "]))}
                  </Typography>
                </Grid>
                <Grid item xs={6} md={4}>
                  <Typography style={{ color: "#70798E" }}>
                    ราคาโปรโมชั่น:
                  </Typography>
                </Grid>
                <Grid item xs={6} md={8} textAlign={"end"}>
                  <Typography style={{ fontSize: 20 }}>
                    {data[" ราคาโปรโมชั่น "]}
                  </Typography>
                </Grid>
              </Grid>
            </Card>
            <Grid style={{ marginTop: 1 }} container padding={1} spacing={4}>
              <Grid item xs={6} md={4}>
                <Typography style={{ color: "#70798E" }}>BU:</Typography>
              </Grid>
              <Grid item xs={6} md={8}>
                <Typography>{data["BU"]}</Typography>
              </Grid>
              <Grid item xs={6} md={4}>
                <Typography style={{ color: "#70798E" }}>
                  {" "}
                  <CalendarTodayIcon style={{ fontSize: 14 }} /> เริ่มต้น:
                </Typography>
              </Grid>
              <Grid item xs={6} md={8}>
                <Typography>
                  {" "}
                  {moment(data["เริ่มต้น"]).format("DD/MM/YYYY")}
                </Typography>
              </Grid>
              <Grid item xs={6} md={4}>
                <Typography style={{ color: "#70798E" }}>
                  {" "}
                  <CalendarTodayIcon style={{ fontSize: 14 }} /> สิ้นสุด:
                </Typography>
              </Grid>
              <Grid item xs={6} md={8}>
                <Typography>
                  {" "}
                  {moment(data["สิ้นสุด"]).format("DD/MM/YYYY")}
                </Typography>
              </Grid>
              <Grid item xs={6} md={4}>
                <Typography style={{ color: "#70798E" }}> Group:</Typography>
              </Grid>
              <Grid item xs={6} md={8}>
                <Typography> {data[" Group "]}</Typography>
              </Grid>
            </Grid>
            <CollapsePromotion
              title={`Max ของแถม (${data[" Max ของแถม "] || "N"})`}
            >
              <Box padding={2}>
                {Array.isArray(data["ของแถม"]) &&
                  data["ของแถม"].map((res) => (
                    <Typography key={res.name}>
                      <CheckCircleIcon
                        style={{ color: "#6ab23a", fontSize: 16 }}
                      />{" "}
                      ของแถม
                      {res.name} : {res.value}
                    </Typography>
                  ))}
              </Box>
            </CollapsePromotion>
            <CollapsePromotion title={"SKUแลกซื้อ"}>
              <Box padding={2}>
                {Array.isArray(data["SKUแลกซื้อ"]) &&
                  data["SKUแลกซื้อ"].map((res, i) => (
                    <Box key={res.name}>
                      <Typography
                        style={{
                          fontWeight: 700,
                          fontSize: 16,
                          padding: "5px 0",
                        }}
                      >
                        SKUแลกซื้อ : {res.value}
                      </Typography>
                      <Box
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "5px 0",
                        }}
                      >
                        <Typography
                          style={{
                            fontWeight: 400,
                            fontSize: 14,
                            padding: "5px 0",
                            color: "#70798E",
                          }}
                        >
                          ราคาขาย Online
                        </Typography>
                        <Typography
                          style={{
                            fontWeight: 400,
                            fontSize: 14,
                            padding: "5px 0",
                          }}
                        >
                          {data["ราคาขาย Online"][i]?.value || 0}
                        </Typography>
                      </Box>
                      <Box
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "5px 0",
                        }}
                      >
                        <Box
                          style={{
                            fontWeight: 400,
                            fontSize: 14,
                            padding: "5px 0",
                            display: "flex",
                          }}
                        >
                          <Typography
                            style={{
                              width: "24px",
                              height: "24px",
                              borderRadius: "50%",
                              backgroundColor: "#FCEEF2",
                              color: "#70798E",
                              marginRight: 5,
                            }}
                          >
                            <ConfirmationNumberIcon
                              style={{
                                color: "red",
                                padding: 5,
                              }}
                            />
                          </Typography>{" "}
                          ส่วนลด
                        </Box>
                        <Typography
                          style={{
                            fontWeight: 400,
                            fontSize: 14,
                            padding: "5px 0",
                            color: "red",
                          }}
                        >
                          -.{data["ส่วนลด"][i]?.value || 0}
                        </Typography>
                      </Box>
                      <Box
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "5px 0",
                        }}
                      >
                        <Typography
                          style={{
                            fontWeight: 400,
                            fontSize: 14,
                            padding: "5px 0",
                            color: "#70798E",
                          }}
                        >
                          ราคา Pro แลกซื้อ
                        </Typography>
                        <Typography
                          style={{
                            fontWeight: 400,
                            fontSize: 20,
                            padding: "5px 0",
                          }}
                        >
                          {data["ราคา Pro แลกซื้อ"][i]?.value || 0}
                        </Typography>
                      </Box>
                      <Divider />
                    </Box>
                  ))}
              </Box>
            </CollapsePromotion>
            <CollapsePromotion title={`แลกซื้อ OPPO`}>
              <Box padding={2}>
                {Array.isArray(data["SKUแลกซื้อ"]) &&
                  data["แลกซื้อ OPPO"].map((res, i) => (
                    <Box key={res.name}>
                      <Box
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "5px 0",
                        }}
                      >
                        <Typography
                          style={{
                            fontWeight: 400,
                            fontSize: 14,
                            padding: "5px 0",
                            color: "#70798E",
                          }}
                        >
                          แลกซื้อ OPPO
                        </Typography>
                        <Typography
                          style={{
                            fontWeight: 400,
                            fontSize: 14,
                            padding: "5px 0",
                          }}
                        >
                          {res.value}
                        </Typography>
                      </Box>
                      <Box
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "5px 0",
                        }}
                      >
                        <Box
                          style={{
                            fontWeight: 400,
                            fontSize: 14,
                            padding: "5px 0",
                            display: "flex",
                          }}
                        >
                          <Typography
                            style={{
                              width: "24px",
                              height: "24px",
                              borderRadius: "50%",
                              backgroundColor: "#FCEEF2",
                              color: "#70798E",
                              marginRight: 5,
                            }}
                          >
                            <ConfirmationNumberIcon
                              style={{
                                color: "red",
                                padding: 5,
                              }}
                            />
                          </Typography>{" "}
                          ส่วนลด
                        </Box>
                        <Typography
                          style={{
                            fontWeight: 400,
                            fontSize: 14,
                            padding: "5px 0",
                            color: "red",
                          }}
                        >
                          -.
                          {data["ส่วนลด"].filter((v) => v.name > 5)[i]?.value ||
                            0}
                        </Typography>
                      </Box>
                      <Divider />
                    </Box>
                  ))}
              </Box>
            </CollapsePromotion>
          </Box>
        </Fade>
      </Modal>
    </>
  );
};

export default ModalPromotion;
